var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{staticClass:"bg-white border border-gray-300 rounded mb-4"},[_vm._t("header"),_c('div',{staticClass:"p-2"},[_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }